export default __webpack_public_path__ + "static/media/loader_black.153a75f7.gif";